import React, { useState } from "react";
import classes from "./SubscriptionPage.module.css";
import { motion } from "framer-motion";
import { FaCheck } from "react-icons/fa6";
import { MdGamepad, MdCalendarToday, MdArrowForward } from "react-icons/md";
import LinedSection from "../component/LinedSection";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { sendOtp } from "../http/http.js";

const MSISDN_LENGTH = 8;

const PLANS = [
  {
    id: 1,
    packName: "daily",
    amount: 50,
    priceLabel: "50CFA",
    nameKey: "40",
    descKey: "41",
    icon: MdGamepad,
  },
  {
    id: 2,
    packName: "weekly",
    amount: 250,
    priceLabel: "250CFA",
    nameKey: "42",
    descKey: "43",
    icon: MdCalendarToday,
  },
];

const SubscriptionPage = () => {
  const [mobile, setMobile] = useState("");
  const [selectedPlanId, setSelectedPlanId] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleMobileChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, MSISDN_LENGTH);
    setMobile(digitsOnly);
  };

  const handleConfirm = async () => {
    if (!mobile.trim()) {
      alert("Please enter mobile number");
      return;
    }

    if (mobile.length !== MSISDN_LENGTH) {
      alert(`Please enter a valid ${MSISDN_LENGTH}-digit mobile number`);
      return;
    }

    const selectedPack = PLANS.find((p) => p.id === selectedPlanId);
    const msisdn = `228${mobile}`;

    localStorage.setItem("mobile", msisdn);

    const payload = {
      msisdn,
      packId: selectedPack.id,
      pack: selectedPack.packName,
      price: 1,
    };

    try {
      setLoading(true);

      const response = await sendOtp(payload);
      console.log(response, "--send otp api res---");

      if (response.data.status === 2) {
        navigate(`/home`, {
          state: {
            mobile: msisdn,
            pack: {
              packId: selectedPack.id,
              packName: selectedPack.packName,
              amount: selectedPack.amount,
            },
          },
        });
      } else if (response.data.status === 1) {
        navigate("/otp", {
          state: {
            mobile: msisdn,
            pack: {
              packId: selectedPack.id,
              packName: selectedPack.packName,
              amount: selectedPack.amount,
            },
          },
        });
      } else {
        alert(response.data.msg);
      }
    } catch (error) {
      console.error(error);
      alert("Unable to send OTP.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className={classes.main}>
      <div className={classes.glowLayer} />

      <LinedSection />

      <motion.section
        className={classes.container}
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <div className={classes.bgGlowOne} />
        <div className={classes.bgGlowTwo} />

        <div className={classes.topLogoWrap}>
          <img
            src="/images/moovafrica.png"
            alt="UV Gaming"
            className={classes.logoImg}
          />
        </div>

        <div className={classes.headingWrap}>
          <motion.h1
            className={classes.title}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            {t("34")}
            <span> {t("35")}</span>
          </motion.h1>
        </div>

        <div className={classes.card}>
          <div className={classes.tabSwitch}>
            <button
              type="button"
              className={`${classes.tabBtn} ${classes.tabBtnActive}`}
            >
              {t("37")}
            </button>
          </div>

          <div className={classes.formBlock}>
            <label className={classes.label}>{t("38")}</label>

            <div className={classes.phoneField}>
              <div className={classes.phoneCode}>+228</div>
              <input
                type="tel"
                inputMode="numeric"
                placeholder={t("39")}
                value={mobile}
                onChange={handleMobileChange}
                maxLength={MSISDN_LENGTH}
                className={classes.phoneInput}
              />
            </div>
          </div>

          <div className={classes.plansWrap}>
            {PLANS.map((plan) => {
              const isActive = selectedPlanId === plan.id;
              const Icon = plan.icon;

              return (
                <button
                  key={plan.id}
                  type="button"
                  className={`${classes.planCard} ${isActive ? classes.planCardActive : ""}`}
                  onClick={() => setSelectedPlanId(plan.id)}
                >
                  <div className={classes.planIcon}>
                    <Icon />
                  </div>

                  <div className={classes.planInfo}>
                    <div
                      className={`${classes.planName} ${isActive ? classes.planNameActive : ""}`}
                    >
                      {t(plan.nameKey)}
                    </div>

                    <div
                      className={`${classes.planDesc} ${isActive ? classes.planDescActive : ""}`}
                    >
                      {t(plan.descKey)}
                    </div>

                    <div
                      className={`${classes.planPrice} ${isActive ? classes.planPriceActive : ""}`}
                    >
                      {plan.priceLabel}
                    </div>
                  </div>

                  <div
                    className={`${classes.selector} ${isActive ? classes.selectorActive : ""}`}
                  >
                    {isActive && <FaCheck />}
                  </div>
                </button>
              );
            })}
          </div>

          <button
            type="button"
            className={classes.confirmBtn}
            onClick={handleConfirm}
            disabled={loading}
          >
            {t("46")}
            <MdArrowForward className={classes.buttonIcon} />
          </button>
        </div>

        <div className={classes.footerText}>© UVCANN SOLUTIONS LLP</div>
      </motion.section>
    </main>
  );
};

export default SubscriptionPage;


























// import React, { useState } from "react";
// import classes from "./SubscriptionPage.module.css";
// import { motion } from "framer-motion";
// import { FaCheck } from "react-icons/fa6";
// import { MdGamepad, MdArrowForward } from "react-icons/md";
// import LinedSection from "../component/LinedSection";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import { sendOtp } from "../http/http.js";

// const MSISDN_LENGTH = 8;

// const SubscriptionPage = () => {
//   const [mobile, setMobile] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const { t } = useTranslation();

//   const handleMobileChange = (e) => {
   
//     const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, MSISDN_LENGTH);
//     setMobile(digitsOnly);
//   };

//   const handleConfirm = async () => {
//     if (!mobile.trim()) {
//       alert("Please enter mobile number");
//       return;
//     }

//     if (mobile.length !== MSISDN_LENGTH) {
//       alert(`Please enter a valid ${MSISDN_LENGTH}-digit mobile number`);
//       return;
//     }

//     const selectedPack = {
//       packId: 1,
//       packName: "Daily",
//       amount: 50,
//     };

//     const msisdn = `228${mobile}`;

//     localStorage.setItem("mobile", msisdn);

//     const payload = {
//       msisdn,
//     };

//     try {
//       setLoading(true);

//       const response = await sendOtp(payload);
//       console.log(response, "--send otp api res---");
//       if( response.data.status===2){
//         navigate("/home",{
//             state: {
//             mobile: msisdn,
//             pack: selectedPack,
//           },
//         })
//       }
//       else if (response.data.status === 1) {
//         navigate("/otp", {
//           state: {
//             mobile: msisdn,
//             pack: selectedPack,
//           },
//         });
//       } else {
//         alert(response.data.msg);
//       }
//     } catch (error) {
//       console.error(error);
//       alert("Unable to send OTP.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <main className={classes.main}>
//       <div className={classes.glowLayer} />

//       <LinedSection />

//       <motion.section
//         className={classes.container}
//         initial={{ opacity: 0, y: 18 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5, ease: "easeOut" }}
//       >
//         <div className={classes.bgGlowOne} />
//         <div className={classes.bgGlowTwo} />

//         <div className={classes.topLogoWrap}>
//           <img
//             src="/images/moovafrica.png"
//             alt="UV Gaming"
//             className={classes.logoImg}
//           />
//         </div>

//         <div className={classes.headingWrap}>
//           <motion.h1
//             className={classes.title}
//             initial={{ opacity: 0, y: -20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6, ease: "easeOut" }}
//           >
//             {t("34")}
//             <span> {t("35")}</span>
//           </motion.h1>
//         </div>

//         <div className={classes.card}>
//           <div className={classes.tabSwitch}>
//             <button
//               type="button"
//               className={`${classes.tabBtn} ${classes.tabBtnActive}`}
//             >
//               {t("37")}
//             </button>
//           </div>

//           <div className={classes.formBlock}>
//             <label className={classes.label}>{t("38")}</label>

//             <div className={classes.phoneField}>
//               <div className={classes.phoneCode}>+228</div>
//               <input
//                 type="tel"
//                 inputMode="numeric"
//                 placeholder={t("39")}
//                 value={mobile}
//                 onChange={handleMobileChange}
//                 maxLength={MSISDN_LENGTH}
//                 className={classes.phoneInput}
//               />
//             </div>
//           </div>

//           <div className={classes.plansWrap}>
//             <div className={`${classes.planCard} ${classes.planCardActive}`}>
//               <div className={classes.planIcon}>
//                 <MdGamepad />
//               </div>

//               <div className={classes.planInfo}>
//                 <div className={`${classes.planName} ${classes.planNameActive}`}>
//                   {t("40")}
//                 </div>

//                 <div className={`${classes.planDesc} ${classes.planDescActive}`}>
//                   {t("41")}
//                 </div>

//                 <div className={`${classes.planPrice} ${classes.planPriceActive}`}>
//                   50CFA
//                 </div>
//               </div>

//               <div className={`${classes.selector} ${classes.selectorActive}`}>
//                 <FaCheck />
//               </div>
//             </div>
//           </div>

//           <button
//             type="button"
//             className={classes.confirmBtn}
//             onClick={handleConfirm}
//             disabled={loading}
//           >
//             {t("46")}
//             <MdArrowForward className={classes.buttonIcon} />
//           </button>
//         </div>

//         <div className={classes.footerText}>© UVCANN SOLUTIONS LLP</div>
//       </motion.section>
//     </main>
//   );
// };

// export default SubscriptionPage;



















// import React, { useState } from "react";
// import classes from "./SubscriptionPage.module.css";
// import { motion } from "framer-motion";
// import { FaCheck } from "react-icons/fa6";
// import { MdGamepad, MdCalendarToday, MdArrowForward } from "react-icons/md";
// import LinedSection from "../component/LinedSection";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import { sendOtp } from "../http/http.js";


// const plans = [
//   {
//     id: 1,
//     name: "Passe Diário",
//     price: "50CFA",
//     amount: "3.00",
//     description: "24 Horas de Jogos",
//   },
//   // {
//   //   id: 2,
//   //   name: "Passe Semanal",
//   //   price: "250CFA",
//   //   amount: "20.00",
//   //   description: "7 Dias de Acesso",
//   // }

// ];

// const SubscriptionPage = () => {
//   const [selectedPlan, setSelectedPlan] = useState(1);
//   const [mobile, setMobile] = useState("");
// const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const {t}=useTranslation();




//   const handleConfirm = async () => {
//   if (!mobile.trim()) {
//     alert("Please enter mobile number");
//     return;
//   }

//   const selectedPack =
//  {
//           packId: 1,
//           packName: "Daily",
//           amount: 50,
//         }
//       // : {
//       //     packId: 2,
//       //     packName: "Weekly",
//       //     amount: 250,
//       //   };

//   const payload = {
//     msisdn: `228${mobile}`,
//     // packId: selectedPack.packId,
//     // packName: selectedPack.packName,
//     // amount: selectedPack.amount,
//   };

//   try {
//     setLoading(true);

//     const response = await sendOtp(payload);

//     if (response.data.success) {
//       navigate("/otp", {
//         state: {
//           mobile: payload.msisdn,
//           pack: selectedPack,
//         },
//       });
//     } else {
//       alert(response.data.message);
//     }
//   } catch (error) {
//     console.error(error);
//     alert("Unable to send OTP.");
//   } finally {
//     setLoading(false);
//   }
// };

//   return (
//     <main className={classes.main}>
//       <div className={classes.glowLayer} />

//       <LinedSection />

//       <motion.section
//         className={classes.container}
//         initial={{ opacity: 0, y: 18 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5, ease: "easeOut" }}
//       >

//         <div className={classes.bgGlowOne} />
//         <div className={classes.bgGlowTwo} />

//         <div className={classes.topLogoWrap}>
//           <img
//             src="/images/moovafrica.png"
//             alt="UV Gaming"
//             className={classes.logoImg}
//           />
//         </div>

//         <div className={classes.headingWrap}>
//           <motion.h1 
//             className={classes.title}
//             initial={{ opacity: 0, y: -20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6, ease: "easeOut" }}
//           >
//             {t("34")}
//             <span>{" "}{t("35")}</span>
//           </motion.h1>
       
//         </div>

//         <div className={classes.card}>
//           <div className={classes.tabSwitch}>
//             <button
//               type="button"
//               className={`${classes.tabBtn}`}
//               onClick={() => navigate("/login")}
//             >
//               {t("36")}
//             </button>

//             <button
//               type="button"
//               className={`${classes.tabBtn} ${classes.tabBtnActive}`}
//             >
//               {t("37")}
//             </button>
//           </div>

//           <div className={classes.formBlock}>
//             <label className={classes.label}>{t("38")}</label>

//             <div className={classes.phoneField}>
//               <div className={classes.phoneCode}>+228</div>
//               <input
//                 type="tel"
//                 placeholder={t("39")}
//                 value={mobile}
//                 onChange={(e) => setMobile(e.target.value)}
//                 className={classes.phoneInput}
//               />
//             </div>
//           </div>

//           <div className={classes.plansWrap}>
//             {/* {plans.map((plan) => {
//               const isActive = selectedPlan === plan.id;

//               return (
//                 <button
//                   key={plan.id}
//                   type="button"
//                   className={`${classes.planCard} ${isActive ? classes.planCardActive : ""
//                     }`}
//                   onClick={() => setSelectedPlan(plan.id)}
//                 >
//                   <div className={classes.planInfo}>
//                     <div
//                       className={`${classes.planName} ${isActive ? classes.planNameActive : ""
//                         }`}
//                     >
//                       {plan.name}
//                     </div>

//                     <div
//                       className={`${classes.planDesc} ${isActive ? classes.planDescActive : ""
//                         }`}
//                     >
//                       {plan.description}
//                     </div>

//                     <div
//                       className={`${classes.planPrice} ${isActive ? classes.planPriceActive : ""
//                         }`}
//                     >
//                       {plan.price}
//                     </div>
//                   </div>

//                   <div
//                     className={`${classes.selector} ${isActive ? classes.selectorActive : ""
//                       }`}
//                   >
//                     {isActive && <FaCheck />}
//                   </div>
//                 </button>
//               );
//             })} */}


//             <button
//               type="button"
//               className={`${classes.planCard} ${selectedPlan === 1 ? classes.planCardActive : ""
//                 }`}
//               onClick={() => setSelectedPlan(1)}
//             >
//               <div className={classes.planIcon}>
//                 <MdGamepad />
//               </div>

//               <div className={classes.planInfo}>
//                 <div
//                   className={`${classes.planName} ${selectedPlan === 1 ? classes.planNameActive : ""
//                     }`}
//                 >
//                   {t("40")}
//                 </div>

//                 <div
//                   className={`${classes.planDesc} ${selectedPlan === 1 ? classes.planDescActive : ""
//                     }`}
//                 >
//                   {t("41")}
//                 </div>

//                 <div
//                   className={`${classes.planPrice} ${selectedPlan === 1 ? classes.planPriceActive : ""
//                     }`}
//                 >
//                   50CFA
//                 </div>
//               </div>

//               <div
//                 className={`${classes.selector} ${selectedPlan === 1 ? classes.selectorActive : ""
//                   }`}
//               >
//                 {selectedPlan === 1 && <FaCheck />}
//               </div>
//             </button>

//             <button
//               type="button"
//               className={`${classes.planCard} ${selectedPlan === 2 ? classes.planCardActive : ""
//                 }`}
//               onClick={() => setSelectedPlan(2)}
//             >
//               <div className={classes.planIcon}>
//                 <MdCalendarToday />
//               </div>

//               <div className={classes.planInfo}>
//                 <div
//                   className={`${classes.planName} ${selectedPlan === 2 ? classes.planNameActive : ""
//                     }`}
//                 >
//                   {t("42")}
//                 </div>

//                 <div
//                   className={`${classes.planDesc} ${selectedPlan === 2 ? classes.planDescActive : ""
//                     }`}
//                 >
//                   {t("43")}
//                 </div>

//                 <div
//                   className={`${classes.planPrice} ${selectedPlan === 2 ? classes.planPriceActive : ""
//                     }`}
//                 >
//                   250CFA
//                 </div>
//               </div>

//               <div
//                 className={`${classes.selector} ${selectedPlan === 2 ? classes.selectorActive : ""
//                   }`}
//               >
//                 {selectedPlan === 2 && <FaCheck />}
//               </div>
//             </button>

//             {/* <button
//               type="button"
//               className={`${classes.planCard} ${selectedPlan === 3 ? classes.planCardActive : ""
//                 }`}
//               onClick={() => setSelectedPlan(3)}
//             >
//               <div className={classes.planInfo}>
//                 <div
//                   className={`${classes.planName} ${selectedPlan === 3 ? classes.planNameActive : ""
//                     }`}
//                 >
//                   {t("44")}
//                 </div>

//                 <div
//                   className={`${classes.planDesc} ${selectedPlan === 3 ? classes.planDescActive : ""
//                     }`}
//                 >
//                   {t("45")}
//                 </div>

//                 <div
//                   className={`${classes.planPrice} ${selectedPlan === 3 ? classes.planPriceActive : ""
//                     }`}
//                 >
//                   50MT
//                 </div>
//               </div>

//               <div
//                 className={`${classes.selector} ${selectedPlan === 3 ? classes.selectorActive : ""
//                   }`}
//               >
//                 {selectedPlan === 3 && <FaCheck />}
//               </div>
//             </button> */}

//           </div>

//           <button type="button" className={classes.confirmBtn}
//             onClick={handleConfirm}
//           >
//             {t("46")}
//             <MdArrowForward className={classes.buttonIcon} />
//           </button>

//           {/* <div className={classes.bottomNote}>
//             <FaCheck className={classes.noteIcon} />
//             {t("47")}
//           </div> */}
//         </div>

//         <div className={classes.footerText}>
//           © UVCANN SOLUTIONS LLP
//         </div>

    
//       </motion.section>
//     </main>
//   );
// };

// export default SubscriptionPage;